import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { LegalAndPrivacyContext } from "../../context/LegalAndPrivacyContext";
interface LinkType {
  value: string | null;
  label?: string;
}
interface LinksProps {
  links: LinkType[];
}

const selectStyles = {
  container: (base: object) => ({
    ...base,
    height: 40,
  }),
  control: (base: object) => ({
    ...base,
    height: "100%",
    borderRadius: 8,
  }),

  singleValue: (base: object) => ({
    ...base,
    maxWidth: "110%",
  }),
  input: (base: object) => ({
    ...base,
    opacity: 0,
  }),
  indicatorSeparator: (base: object) => ({
    ...base,
    marginTop: 0,
    marginBottom: 0,
  }),
};

const Select: React.FC<LinksProps> = ({ links }): JSX.Element => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const navigate = useNavigate();
  const { setCurrentPage, currentPage } = useContext(LegalAndPrivacyContext);
  const handleChange = (optionSelected: LinkType | null) => {
    setCurrentPage(optionSelected?.value || "");
    searchParams.set("name", optionSelected?.value || "");
    const link = searchParams.toString();
    navigate(`?${link}`);
  };

  return (
    <ReactSelect
      value={links.find(el => el.value === currentPage)}
      options={links}
      onChange={handleChange}
      styles={selectStyles}
    />
  );
};

export default Select;
